import { AdminService } from 'app/API';
import type { TCall } from './types/TCall';

const ADMIN_ROLES_TO_REMOVE = [
  'ROLE_BILLING_ADMIN',
  'ROLE_ORG_ADMIN',
  'ROLE_VS_ADMIN',
  'ROLE_SUPER_ADMIN',
  'ROLE_VS_DEV',
] as const;

export class AdminRemovalError extends Error {
  constructor(failedRoles: string[]) {
    super(`Unable to remove admin roles: ${failedRoles.join(', ')}`);
  }
}

type TParams = {
  call: TCall;
  uid: string;
};

export const removeAdminAccess = async ({ call, uid }: TParams) => {
  const failedRoles: string[] = [];

  for (const role of ADMIN_ROLES_TO_REMOVE) {
    try {
      const response = await call(() => AdminService.toggleAdminRole({ uid, requestBody: { role, value: false } }));

      if (!response.success) {
        failedRoles.push(role);
      }
    } catch {
      failedRoles.push(role);
    }
  }

  if (failedRoles.length > 0) {
    throw new AdminRemovalError(failedRoles);
  }
};
